export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /tmp/build_713add00/src/environments/environment.ts